<div class="system-map">
    <div class="system-map__layers">
        <div class="system-map__selector"></div>
    </div>

    <div class="system-map-info info-panel info-panel--open">


    </div>
</div>